import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    Renderer2,
    SimpleChanges,
    TemplateRef,
} from "@angular/core";
import {
    GROWLER_FADEOUT_DURATION_MS,
    GROWLER_VISIBLE_DURATION_MS,
    GrowlerIcon,
    GrowlerKind,
} from "@spscommerce/ds-shared";

@Component({
    selector: "sps-growler-internal",
    templateUrl: "./sps-growler-internal.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsGrowlerInternalComponent implements OnChanges, OnInit {
    @Input() title: string;
    @Input() kind: GrowlerKind = GrowlerKind.INFO;
    @Input() imgSrc: string;
    @Input() template: TemplateRef<any>;

    @Output() close = new EventEmitter<void>();

    @HostBinding("attr.role") readonly _role = "alert";

    @HostBinding("class.sps-growler") readonly _spsGrowlerClass = true;

    @HostBinding("class.show")
    shown = true;

    @HostBinding("class.fade")
    fade = false;

    timeToFade: number;
    timeToHide: number;

    // Progress growlers are special because they have a spinner instead of an icon
    get isProgressGrowler() {
        return this.kind === GrowlerKind.PROGRESS;
    }

    get iconClass() {
        return {
            "sps-icon": !this.isProgressGrowler,
            [`sps-icon-${GrowlerIcon.get(this.kind)}`]: !this.isProgressGrowler,
            "sps-spinner": this.isProgressGrowler,
        };
    }

    constructor(
        private _changeDetector: ChangeDetectorRef,
        private _elementRef: ElementRef,
        private _renderer: Renderer2
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.kind) {
            this._renderer.removeClass(this._elementRef.nativeElement, `sps-growler--${changes.kind.previousValue}`);
            this._renderer.addClass(this._elementRef.nativeElement, `sps-growler--${changes.kind.currentValue}`);
        }
    }

    ngOnInit() {
        this._renderer.addClass(this._elementRef.nativeElement, `sps-growler--${this.kind}`);
        if (!this.isProgressGrowler) {
            this.startTimers();
        }
    }

    @HostListener("mouseenter")
    cancelTimers() {
        if (!this.isProgressGrowler) {
            window.clearTimeout(this.timeToFade);
            window.clearTimeout(this.timeToHide);
            this.fade = false;
        }
    }

    @HostListener("mouseleave")
    startTimers() {
        if (!this.isProgressGrowler) {
            this.timeToFade = window.setTimeout(() => {
                this.fade = true;
                this._changeDetector.markForCheck();
            }, GROWLER_VISIBLE_DURATION_MS);
            this.timeToHide = window.setTimeout(() => {
                this.shown = false;
                this._changeDetector.markForCheck();
                this.close.emit();
            }, GROWLER_VISIBLE_DURATION_MS + GROWLER_FADEOUT_DURATION_MS);
        }
    }

    closeGrowler() {
        this.cancelTimers();
        this.shown = false;
        this.fade = false;
        this._changeDetector.markForCheck();
        this.close.emit();
    }
}
